import { render, staticRenderFns } from "./QuestionTotal.vue?vue&type=template&id=77b33bac&scoped=true&"
import script from "./QuestionTotal.vue?vue&type=script&lang=js&"
export * from "./QuestionTotal.vue?vue&type=script&lang=js&"
import style0 from "./QuestionTotal.vue?vue&type=style&index=0&id=77b33bac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b33bac",
  null
  
)

export default component.exports